import React, { useEffect, useState, useMemo } from "react";
import { Hooks,Context,XtLocale,Util } from "@xt/xtbase";
const {XtContext} = Context;
const {useTranslation} = Hooks;
import styles from "./index.module.less";
import { getBannerList, filterBannerListByLogin } from "@/api/xt-app";
import { observer } from 'mobx-react-lite';
import {Carousel} from "antd";
import Slider from "react-slick";
import nextArrow from "assets/images/nextArrow.png";
import nextArrowH from "assets/images/nextArrowH.png";
import prevArrow from "assets/images/prevArrow.png";
import prevArrowH from "assets/images/prevArrowH.png";

const HomeScrollCard = () => {
  const t = useTranslation();
  const [appState] = React.useContext(XtContext);
  const { lang, theme, loginStatus } = appState;
  const isLogin = loginStatus === 1;
  const [allCarouselList, setAllCarouselList] = useState([]);
  const [cur, setCur] = useState(0);
  const carouselList = useMemo(
    () => filterBannerListByLogin(allCarouselList, isLogin),
    [allCarouselList, isLogin],
  );

  const initBanner = async () => {
    const res = await getBannerList({ params: { type: 1 } });
    setAllCarouselList(Array.isArray(res) ? res : []);
  };

  useEffect(() => {
    initBanner();
  }, []);

  useEffect(() => {
    setCur((c) =>
      carouselList.length ? Math.min(c, carouselList.length - 1) : 0,
    );
  }, [carouselList.length]);
  const handelBannerList = (size)=>{
    const list = carouselList
      if (list.length <= size) return [list];
      const groupNum = Math.ceil(list.length / size);
      const leftNum = size - (list.length % size);
      let resultList = [];
      for (let i = 0; i < groupNum; i++) {
        let tempList = list.slice(i * size, (i + 1) * size);
        if (i === groupNum - 1 && leftNum > 0 && leftNum < size) {
          tempList = [...tempList, ...list.slice(0, leftNum)];
        }
        resultList.push(tempList);
      }
      return resultList;
  }
  const handlePhoneCli = ()=>{
    let address = carouselList[cur].link;
    if (!address) return;
    window.open(address, "_self");
  }
  const getBannerImg = (item)=>{
    if (!item) return;
    if (theme === "dark") {
      return item.nightBanner ? item.nightBanner : item.dayBanner;
    }
    return item.dayBanner ? item.dayBanner : item.nightBanner;
  }
  const onActClick = (item)=>{
    if (!item.link) return;
    window.open(item.link, "_self");
  }

  const [hoverIndex, setHoverIndex] = useState(-1)

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 5000,
    cssEase: "linear",
    arrows: true,
    nextArrow: <img onMouseEnter={()=>setHoverIndex(1)} onMouseLeave={()=>setHoverIndex(-1)} src={hoverIndex == 1 ? nextArrow : nextArrowH} style={{width: '30px', height: '30px', transition: 'all 0.3s linear'}} />,
    prevArrow: <img onMouseEnter={()=>setHoverIndex(2)} onMouseLeave={()=>setHoverIndex(-1)} src={hoverIndex == 2 ? prevArrow : prevArrowH} style={{width: '30px', height: '30px', transition: 'all 0.3s linear'}} />
  };

  return carouselList.length ? <div className={`${styles["banner-carousel"]} HomeScrollCard`}>
    <div className={styles["phone-click-mask"]} onClick={handlePhoneCli}></div>
    <div className={styles.carousel1200}>
    {carouselList.length > 3 ? <Carousel autoplay={true} easing="ease-in-out" {...settings}>
      {handelBannerList(1).map((items, i)=>{
        return <div className={`${styles["activity-view"]} ${i == 0 ? 'activity-view1' : ''}`} key={"home_scroll_"+i}>
          <ul className={styles["child-act-"+items.length]}>
            {items.map((item, j)=>{
              return <li key={"home_scroll_"+i+"_"+j}>
                <img className={styles["smallBanner"]}  src={getBannerImg(item)} onClick={()=>{onActClick(item)}} />
              </li>
            })}
          </ul>
        </div>
      })}
    </Carousel> :
    <div style={{ display: 'flex', marginBottom: '28px'}}>
      {handelBannerList(1).map((items, i)=>{
        return <div className={`${styles["activity-view"]} ${styles["activity-view"+(i + 1)]}`} key={"home_scroll_"+i}>
          <ul className={styles["child-act-"+items.length]}>
            {items.map((item, j)=>{
              return <li key={"home_scroll_"+i+"_"+j}>
                <img src={getBannerImg(item)} onClick={()=>{onActClick(item)}} />
              </li>
            })}
          </ul>
        </div>
      })}
    </div>}
    </div>
    <div className={styles.carousel768}>
    <Carousel autoplay={true} easing="ease-in-out" afterChange={(cur)=>{setCur(cur)}}>
      {handelBannerList(1).map((items, i)=>{
        return <div className={styles["activity-view"]} key={"home_scroll_phone_"+i}>
          <ul>
            {items.map((item, j)=>{
              return <li key={"home_scroll_phone_"+i+"_"+j}>
                <img src={getBannerImg(item)} />
              </li>
            })}
          </ul>
        </div>
      })}
    </Carousel>
    </div>
  </div> : <></>;
}
export default observer(HomeScrollCard);
